/* eslint-disable no-unused-vars */
import { createRouter, createWebHashHistory } from 'vue-router';
import { GetRouteAccess } from '../services/Users/GetRouteAccess';
import routes from './routes';
import { useRouteAccessStore } from '../stores/routeAccess';
import { useGlobalLoaderStore } from '../stores/globalLoader';
import { GetDashboardAccess } from '../services/DashboardAccess/GetDashboardAccess';
import { GetFeatureFlag } from '../services/FeatureFlags/GetFeatureFlag';
import {
  hasNoAccess,
  redirectNoAccess,
  redirectToLegacy,
  processAccess,
  resetPanels,
  checkReRoutes,
  setLaunchDarklyFlags,
} from './router-business';
import { FeatureFlagIdEnum } from '../enums/featureFlagIds';
import { GetLaunchDarklyFlags } from '../services/LaunchDarkly/GetLaunchDarkly';

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const checkAccess = (response, to) => {
  return (
    response.isAuthenticated &&
    response.isAllowedToAccess &&
    !hasNoAccess(to.name, response.accessLevelStatus)
  );
};

const processRoutes = async (moduleId, to, loader) => {
  const checkRouteAccessResponse = await checkRouteAccess(moduleId, to);
  if (checkRouteAccessResponse) {
    const { response, queryString } = checkRouteAccessResponse;
    await processLaunchDarkly();
    await processAccessAndReRoutes(response, to, queryString, loader);
  }
};

const checkRouteAccess = async (moduleId, to) => {
  try {
    const response = await GetRouteAccess(moduleId);
    const type = 'fintech';
    const toPath = encodeURIComponent(to.path);
    const queryString = `?path=${toPath}&type=${type}`;

    if (!checkAccess(response, to)) {
      redirectNoAccess(response, queryString);
      return false;
    }
    const fintechFeatureFlag = await GetFeatureFlag(
      FeatureFlagIdEnum.enableFintechNavigation
    );
    if (!fintechFeatureFlag.keyValue) {
      redirectNoAccess(response, queryString);
      return false;
    }
    return { response, queryString };
  } catch (error) {
    console.error(error);
  }
};

const processAccessAndReRoutes = async (response, to, queryString, loader) => {
  try {
    const routeAccessStore = useRouteAccessStore();
    const res = await GetDashboardAccess();

    processAccess(routes, res);

    checkReRoutes(router, response, to, queryString);

    resetPanels();

    if (loader.isSideNavLoading) {
      loader.hideSideNavLoader();
    }
    if (loader.loading) {
      loader.hideLoader();
    }

    routeAccessStore.$patch({ routeAccess: { ...response } });
  } catch (error) {
    console.log(error);
    redirectNoAccess(response, queryString);
  }
};

const processLaunchDarkly = async () => {
  try {
    const LDFlags = await GetLaunchDarklyFlags();
    setLaunchDarklyFlags(LDFlags);
  } catch (error) {
    console.error(error);
  }
};

router.beforeEach(async (to, from, next) => {
  if (to.name === 'route-to-v1') {
    redirectToLegacy(to.query.redirectTo);

    return;
  }

  if ('auth' in to.meta && to.meta.auth) {
    const loader = useGlobalLoaderStore();
    const moduleId = to.meta.moduleId;

    if (from.fullPath === '/') loader.showLoader();
    else loader.showSideNavLoader();
    await processRoutes(moduleId, to, loader);
  }

  next();
});

const DEFAULT_TITLE = 'Finances | Sprout HR';

router.afterEach((to) => {
  document.title = to.meta.pageName
    ? `${to.meta.pageName.toString()} | Finances`
    : DEFAULT_TITLE;
});

export default router;
